import "../css/ckeditor"

import { Essentials, Paragraph, Code, Bold, Italic, Underline, Strikethrough, Subscript, Superscript } from "ckeditor5"
import "ckeditor5/ckeditor5.css"

export default {
  plugins: [Essentials, Paragraph, Code, Bold, Italic, Underline, Strikethrough, Subscript, Superscript],
  toolbar: ["code",  "|",  "bold",  "italic",  "underline",  "strikethrough",  "|",  "subscript",  "superscript"],
  language: "en",
  licenseKey: "GPL"
}
